import { store } from "../../../../..";
import { clubhouseActions } from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectFields,
} from "../../../../../features/global/globalSlice";

const loader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);

    const { user } = store.getState().auth;
    const teams = store.getState().clubhouse.teams;
    const settings = store.getState().global.settings;
    const ageLevels = store.getState().global.ageLevels;
    const fields = selectFields(store.getState());
    const promises = [];

    !teams.length &&
        promises.push(
            store.dispatch(
                clubhouseActions.getTeams({ userId: user?.id as number }),
            ),
        );

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    !fields.length && promises.push(store.dispatch(globalActions.getFields()));
    !ageLevels.length &&
        promises.push(store.dispatch(globalActions.getAgeLevels()));

    await Promise.all(promises);

    return {
        teamId,
    };
};

export default loader;
